import {http, onSuccess, onFail} from "./http";

export const getEvent = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}`)
        .then(onSuccess, onFail);

export const getEventModules = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/module`)
        .then(onSuccess, onFail);

export const getEvents = (params) =>
    http.get(`/api/cp/event`, {params})
        .then(onSuccess, onFail);
